import { Card, Grid, TextField, Switch, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, FormControl, InputLabel, Select, MenuItem, FormHelperText, Alert, Box, Icon, Checkbox, ListItemText, Chip } from "@mui/material";
import React, { useState } from "react";
import WDBox from "../../../../MaterialComponents/WDBox";
import WDButton from "../../../../MaterialComponents/WDButton";
import WDTypography from "../../../../MaterialComponents/WDTypography";
import AppService from "../../../../Configurations/Appservice";

import { Formik, Form, Field } from "formik";
import { object, string } from "yup";
import { useEffect, useRef } from "react";
import { CUSTOMER_ORG_TYPE } from "../../../../Configurations/AppConfig";
import { useDispatch } from "react-redux";
import {
  dismissLoader,
  showLoader,
  showSuccessMessage,
  updateScreenTitle,
} from "../../../../LayoutContainers/AppLayout/redux/AppSlice";
import { useLocation } from "react-router-dom";
import { Divider } from "@mui/material";
import ServicePartnerOnboardingSection from "../../../../Components/ServicePartnerOnboarding/ServicePartnerOnboardingSection";

const initialValues = {
  name: "",
  tradeLicenseNumber: "",
  contactPerson: "",
  email: "",
  contactNumber: "",
  address: "",
  active: true,
  organizationCategory: "",
  businessCategoryId: "",
  serviceTypes: [],
};

const validationSchema = object({
  name: string().required("Name is Mandatory"),
  contactPerson: string().required("Contact Person Info is Mandatory"),
  email: string().email().required("Email is Mandatory"),
  contactPerson: string().required("Contact Number is Mandatory"),
  address: string().required("Address is Mandatory"),
});

const EditCustomerOrganisation = () => {
  // Dialog and pending value state for status toggle
  const [open, setOpen] = useState(false);
  const [pendingValue, setPendingValue] = useState(false);
  const [organizationCategories, setOrganizationCategories] = useState([]);
  const [businessCategories, setBusinessCategories] = useState([]);
  const [isCustomerOrg, setIsCustomerOrg] = useState(false);
  const [isPartnerOrg, setIsPartnerOrg] = useState(false);
  const [serviceTypes, setServiceTypes] = useState([]);
  // Check if current user is admin
  const isAdmin = () => {
    try {
      const principalInfoRaw = JSON.parse(localStorage.getItem("principalInfo"));
      const principalInfo = principalInfoRaw.principalInfo || principalInfoRaw;
      console.log("[DEBUG] principalInfo (final):", principalInfo);
      const isRootAdmin = principalInfo && principalInfo.roles && principalInfo.roles.includes("ROOT_ADMIN");
      console.log("[DEBUG] isRootAdmin:", isRootAdmin);
      return isRootAdmin;
    } catch (e) {
      console.log("[DEBUG] Error in isAdmin:", e);
      return false;
    }
  };



  const dispatch = useDispatch();
  const location = useLocation();
  const formikRef = useRef();
  // Service-partner onboarding ref — only used when the org being edited is a PARTNER.
  const onboardingRef = useRef(null);

  useEffect(() => {
    dispatch(updateScreenTitle("Edit Organisation"));
    
    // Load organization categories from API
    AppService.get("api/organisations/categories")
      .then((response) => {
        setOrganizationCategories(response || []);
      })
      .catch((error) => {
        console.error("Failed to load organization categories", error);
      });
    
    // Load business categories from API
    AppService.get("api/business-categories/list-details")
      .then((response) => {
        setBusinessCategories(response || []);
      })
      .catch((error) => {
        console.error("Failed to load business categories", error);
      });

    // Load service types from API
    AppService.get("api/organisations/partner-service-types")
      .then((response) => {
        setServiceTypes(response || []);
      })
      .catch((error) => {
        console.error("Failed to load service types", error);
      });

    return () => dispatch(updateScreenTitle(""));
  }, []);

  useEffect(() => {
    dispatch(showLoader());
    const organisationId = location.state?.organisationId;
    let params = {
      organisationId,
    };
    if (!organisationId) {
      dispatch(dismissLoader());
      return;
    }

    AppService.get("v1/organisation/details", { params })
      .then((response) => {
        formikRef.current.setFieldValue("name", response.name);
        formikRef.current.setFieldValue("contactPerson", response.contactPerson);
        formikRef.current.setFieldValue("email", response.email);
        formikRef.current.setFieldValue("contactNumber", response.contactNumber);
        formikRef.current.setFieldValue("address", response.address);
        if (typeof response.active !== 'undefined') {
          formikRef.current.setFieldValue("active", response.active);
        }
        // Set organization category
        if (response.organizationCategory) {
          formikRef.current.setFieldValue("organizationCategory", response.organizationCategory);
        }
        // Set business category (only for customer organizations)
        if (response.businessCategoryId) {
          formikRef.current.setFieldValue("businessCategoryId", response.businessCategoryId);
        }
        // Set trade license number
        if (response.tradeLicenseNumber) {
          formikRef.current.setFieldValue("tradeLicenseNumber", response.tradeLicenseNumber);
        }
        // Check organization type
        if (response.type === "CUSTOMER") {
          setIsCustomerOrg(true);
        }
        if (response.type === "PARTNER") {
          setIsPartnerOrg(true);
          if (response.serviceTypes && response.serviceTypes.length > 0) {
            formikRef.current.setFieldValue("serviceTypes", response.serviceTypes);
          }
        }
      })
      .catch(() => {})
      .finally(() => {
        dispatch(dismissLoader());
      });
  }, []);

  const _onSubmit = async (values, { resetForm }) => {
    values.id = location.state.organisationId;
    if (!values.businessCategoryId) {
      values.businessCategoryId = null;
    }
    if (!values.organizationCategory) {
      values.organizationCategory = null;
    }
    if (!values.serviceTypes || values.serviceTypes.length === 0) {
      values.serviceTypes = [];
    }

    // For partner orgs, run validation + low-share confirmation BEFORE any
    // API call. If the user cancels the confirmation, abort the whole submit
    // — don't leave the org PUT applied while the onboarding update is rejected.
    if (isPartnerOrg && onboardingRef.current?.isFilled()) {
      const ok = await onboardingRef.current.validate();
      if (!ok) return; // user cancelled — nothing has been written yet
    }

    dispatch(showLoader());
    try {
      await AppService.put("v1/organisation", values);
      if (isPartnerOrg && onboardingRef.current?.isFilled()) {
        try {
          await onboardingRef.current.save(values.id);
        } catch (e) {
          console.error("Failed to save service partner onboarding", e);
          dispatch(showSuccessMessage("Organisation updated — but failed to save profit-share. Please retry the onboarding section."));
          return;
        }
      }
      resetForm();
      dispatch(showSuccessMessage("Organisation updated successfully"));
    } catch (error) {
      // Error already surfaced by AppService global handler
    } finally {
      dispatch(dismissLoader());
    }
  };

  return (
    <WDBox py={1}>
      <Card sx={{ padding: 3 }}>
        <Formik
          initialValues={initialValues}
          onSubmit={_onSubmit}
          validationSchema={validationSchema}
          innerRef={formikRef}
        >
          {({ errors, isValid, touched, dirty }) => (
            <Form>
              <WDBox>
                <WDTypography fontSize={14}>Edit Organisation</WDTypography>
              </WDBox>
              <WDBox my={3}>
                <Grid container spacing={3}>
                  {isAdmin() && (
                    <Grid item xs={12} md={3}>
                      <WDBox>
                        <Field name="active">
                          {({ field, form }) => {
                            // Get userType from principalInfo
                            let userType = "";
                            try {
                              const principalInfoRaw = JSON.parse(localStorage.getItem("principalInfo"));
                              const principalInfo = principalInfoRaw.principalInfo || principalInfoRaw;
                              userType = principalInfo.userType;
                            } catch {}
                            return (
                              <>
                                <label>Status:&nbsp;</label>
                                <Switch
                                  checked={field.value}
                                  onChange={() => {
                                    setPendingValue(!field.value);
                                    setOpen(true);
                                  }}
                                />
                                {field.value ? "Active" : "Inactive"}
                                <Dialog open={open} onClose={() => setOpen(false)}>
                                  <DialogTitle>Confirm Status Change</DialogTitle>
                                  <DialogContent>
                                    <DialogContentText>
                                      Are you sure you want to set status to <b>{pendingValue ? "Active" : "Inactive"}</b>?<br/>
                                      <br/>
                                      <b>User Type:</b> {userType}
                                    </DialogContentText>
                                  </DialogContent>
                                  <DialogActions>
                                    <Button onClick={() => setOpen(false)} color="inherit">Cancel</Button>
                                    <Button onClick={() => {
                                      form.setFieldValue("active", pendingValue);
                                      setOpen(false);
                                    }} color="primary" autoFocus>
                                      Confirm
                                    </Button>
                                  </DialogActions>
                                </Dialog>
                              </>
                            );
                          }}
                        </Field>
                      </WDBox>
                    </Grid>
                  )}

                  <Grid item xs={12} md={3}>
                    <WDBox>
                      <Field
                        name="name"
                        label="Name"
                        fullWidth
                        as={TextField}
                        error={Boolean(errors.name) && Boolean(touched.name)}
                        helperText={Boolean(touched.name) && errors.name}
                      />
                    </WDBox>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <WDBox>
                      <Field
                        name="contactPerson"
                        label="Contact Person"
                        fullWidth
                        as={TextField}
                        error={Boolean(errors.contactPerson) && Boolean(touched.contactPerson)}
                        helperText={Boolean(touched.contactPerson) && errors.contactPerson}
                      />
                    </WDBox>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <WDBox>
                      <Field
                        name="email"
                        type="email"
                        label="Email"
                        fullWidth
                        as={TextField}
                        error={Boolean(errors.email) && Boolean(touched.email)}
                        helperText={Boolean(touched.email) && errors.email}
                      />
                    </WDBox>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <WDBox>
                      <Field
                        name="contactNumber"
                        label="Contact Number"
                        fullWidth
                        as={TextField}
                        error={Boolean(errors.contactNumber) && Boolean(touched.contactNumber)}
                        helperText={Boolean(touched.contactNumber) && errors.contactNumber}
                      />
                    </WDBox>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <WDBox>
                      <Field
                        name="tradeLicenseNumber"
                        label="Trade License Number"
                        fullWidth
                        as={TextField}
                      />
                    </WDBox>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <WDBox>
                      <Field
                        name="address"
                        label="Address"
                        fullWidth
                        as={TextField}
                        error={Boolean(errors.address) && Boolean(touched.address)}
                        helperText={Boolean(touched.address) && errors.address}
                      />
                    </WDBox>
                  </Grid>

                  {/* Organization Category */}
                  <Grid item xs={12} md={3}>
                    <Field name="organizationCategory">
                      {({ field, form }) => (
                        <FormControl fullWidth>
                          <InputLabel>Organization Category</InputLabel>
                          <Select
                            {...field}
                            label="Organization Category"
                            onChange={(e) => form.setFieldValue("organizationCategory", e.target.value)}
                          >
                            {organizationCategories.map((type) => (
                              <MenuItem key={type.code} value={type.code}>
                                {type.label}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}
                    </Field>
                  </Grid>
                  
                  {/* Service Types - Only shown for partner organizations */}
                  {isPartnerOrg && (
                    <Grid item xs={12} md={3}>
                      <Field name="serviceTypes">
                        {({ field, form }) => (
                          <FormControl fullWidth>
                            <InputLabel>Service Types</InputLabel>
                            <Select
                              multiple
                              value={field.value || []}
                              label="Service Types"
                              onChange={(e) => form.setFieldValue("serviceTypes", e.target.value)}
                              renderValue={(selected) => (
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                  {selected.map((val) => (
                                    <Chip key={val} label={val} size="small" />
                                  ))}
                                </Box>
                              )}
                            >
                              {serviceTypes.map((type) => (
                                <MenuItem key={type} value={type}>
                                  <Checkbox checked={(field.value || []).indexOf(type) > -1} />
                                  <ListItemText primary={type} />
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        )}
                      </Field>
                    </Grid>
                  )}

                  {/* Business Category - Only shown for customer organizations */}
                  {isCustomerOrg && (
                    <Grid item xs={12} md={3}>
                      <Field name="businessCategoryId">
                        {({ field, form }) => (
                          <FormControl fullWidth>
                            <InputLabel>Business Category</InputLabel>
                            <Select
                              {...field}
                              label="Business Category"
                              onChange={(e) => form.setFieldValue("businessCategoryId", e.target.value)}
                            >
                              {businessCategories.map((category) => (
                                <MenuItem key={category.id} value={category.id}>
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Icon sx={{ color: category.colour, fontSize: 20 }}>{category.icon}</Icon>
                                    <span>{category.name}</span>
                                  </Box>
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        )}
                      </Field>
                    </Grid>
                  )}
                  
                  {/* Business Category Info Alert - Only shown for customer organizations */}
                  {isCustomerOrg && formikRef.current?.values?.businessCategoryId && (
                    <Grid item xs={12}>
                      {(() => {
                        const selectedCategory = businessCategories.find(c => c.id === formikRef.current?.values?.businessCategoryId);
                        if (!selectedCategory) return null;
                        const requiredDocs = selectedCategory.documents || [];
                        const mandatoryDocs = requiredDocs.filter(d => d.isMandatory);

                        return (
                          <Alert
                            severity="info"
                            icon={<Icon>{selectedCategory.icon}</Icon>}
                            sx={{
                              backgroundColor: `${selectedCategory.colour}15`,
                              '& .MuiAlert-icon': { color: selectedCategory.colour }
                            }}
                          >
                            <WDTypography variant="body2" fontWeight="medium">
                              {selectedCategory.name}
                            </WDTypography>
                            <WDTypography variant="caption" color="text.secondary">
                              {selectedCategory.description}
                            </WDTypography>
                            {mandatoryDocs.length > 0 && (
                              <WDTypography variant="caption" display="block" mt={1}>
                                <strong>Industry-specific documents required:</strong>{" "}
                                {mandatoryDocs.map(d => d.documentTypeName || d.documentTypeCode.replace(/_/g, ' ')).join(', ')}
                              </WDTypography>
                            )}
                          </Alert>
                        );
                      })()}
                    </Grid>
                  )}
                </Grid>
              </WDBox>

              {isPartnerOrg && (
                <>
                  <Divider sx={{ my: 3 }} />
                  <ServicePartnerOnboardingSection
                    ref={onboardingRef}
                    organisationId={location.state?.organisationId}
                  />
                </>
              )}

              <WDBox display="flex" justifyContent="flex-end" pt={3}>
                {/* For partner orgs the onboarding section lives outside Formik,
                    so Formik's `dirty` / `isValid` don't reflect onboarding-only
                    edits. Don't gate the submit button on either for partners —
                    Yup will still block the actual submit if org fields are invalid. */}
                <WDButton
                  variant="gradient"
                  disabled={!isPartnerOrg && (!dirty || !isValid)}
                  type="submit"
                >
                  Submit
                </WDButton>
              </WDBox>
            </Form>
          )}
        </Formik>
      </Card>
    </WDBox>
  );
};

export default EditCustomerOrganisation;
